import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  AaNgModule,
  INSTITUTION_CONTEXT_TOKEN,
  ISTPersonActivity,
  PersonProfile,
} from 'aa-ng';
import { QuicklinkDirective } from 'ngx-quicklink';

import { PersonUrlPipe } from '../../pipes/person-url.pipe';
import {
  ActivityCollaboratorsService,
  InstitutionsService,
  MAX_SCHOLARS_TO_DISPLAY,
} from '../../services';
import { BaseDirective } from '../base.component';

@Component({
  selector: 'app-collaborative-network-popup',
  imports: [AaNgModule, PersonUrlPipe, QuicklinkDirective, RouterLink],
  templateUrl: './collaborative-network-popup.component.html',
})
export class CollaborativeNetworkPopupComponent extends BaseDirective {
  institutionsService = inject<InstitutionsService>(INSTITUTION_CONTEXT_TOKEN);
  private activityCollaboratorsService = inject(ActivityCollaboratorsService);

  @Input() profile: PersonProfile;
  @Input() activities: ISTPersonActivity[];
  @Input() showViewProfileButton = true;
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<boolean>();
  customUnitGroupingTitles: { [key: string]: string } = {};

  /** Shared with the fetch, which asks for one more than this to know if there is a next page. */
  maxScholarsToDisplay = MAX_SCHOLARS_TO_DISPLAY;

  constructor() {
    super();

    this._subscriptions.push(
      this.institutionsService.context.subscribe((context) => {
        this.customUnitGroupingTitles = context.customUnitGroupingTitles;
      }),
    );
  }

  /**
   * The inline scholars for one work. These activities arrive with no contributors - the profile payload
   * asks for them that way - so each row fetches its own first page on demand.
   */
  showPeople(activity: ISTPersonActivity) {
    this._subscriptions.push(
      this.activityCollaboratorsService.fetchFirstPage(activity).subscribe({
        next: (resultSet) => {
          const row = this.activities?.find(
            (a) =>
              a.id === activity.id &&
              a.activityTypeId === activity.activityTypeId,
          );

          if (row) {
            row.contributors = this.activityCollaboratorsService.toContributors(
              resultSet?.results,
            );
          }
        },
        error: (err) => console.error('showPeople error', err),
      }),
    );
  }

  showAllCollaborators(activity: ISTPersonActivity) {
    this.activityCollaboratorsService.openModal(activity);
  }

  closePopup() {
    this.close.emit(true);
  }
}
